import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASS = "survey-pair-card--active"

// Connects to data-controller="survey-viewer"
// Owns keyboard-driven selection between A/B variant cards.
// ArrowLeft  → focus card A
// ArrowRight → focus card B
// Enter      → submit the currently active card's choice button
export default class extends Controller {
  static targets = ["card"]

  connect() {
    if (this.cardTargets.length > 0 && this.activeIndex() === -1) {
      this.setActive(0, { focus: false })
    }
  }

  onKey(event) {
    if (this.cardTargets.length < 2) return

    switch (event.key) {
      case "ArrowLeft":
        event.preventDefault()
        this.setActive(0)
        break
      case "ArrowRight":
        event.preventDefault()
        this.setActive(1)
        break
      case "Enter":
        if (this.activeCard()) {
          event.preventDefault()
          this.submitActive()
        }
        break
    }
  }

  selectCard(event) {
    const card = event.currentTarget
    const idx = this.cardTargets.indexOf(card)
    if (idx !== -1) this.setActive(idx)
  }

  setActive(index, { focus = true } = {}) {
    this.cardTargets.forEach((card, i) => {
      const isActive = i === index
      card.classList.toggle(ACTIVE_CLASS, isActive)
      card.setAttribute("aria-pressed", isActive ? "true" : "false")
      card.tabIndex = isActive ? 0 : -1
    })
    if (focus) {
      const active = this.cardTargets[index]
      if (active) active.focus({ preventScroll: true })
    }
    this.dispatch("activated", { detail: { index } })
  }

  submitActive() {
    const active = this.activeCard()
    if (!active) return
    const button = active.querySelector(".survey-pair-choose")
    if (button) button.click()
  }

  activeCard() {
    return this.cardTargets.find((card) => card.classList.contains(ACTIVE_CLASS))
  }

  activeIndex() {
    return this.cardTargets.findIndex((card) => card.classList.contains(ACTIVE_CLASS))
  }
}
